import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPromoCodeCheckIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M9 19l-6-7h1.5l4.49 5.36L19.5 5H21L9 19z",
		style: { fill: "rgb(25, 126, 16)" }
	})]
});
const ForwardRef = forwardRef(SvgPromoCodeCheckIcon);
export default ForwardRef;
